import { PersonaGroupList } from '@/modules/group/modules/groups/domain/models/PersonaGroupList'

import { axios, Response } from '../../index'

export default async function getPublishableGroups(
  personId: string
): Response<PersonaGroupList> {
  return await axios.get(`/v1/personas/${personId}/group-publish`)
}
